<template>

  <svg xmlns="http://www.w3.org/2000/svg" id="flag-icons-ua" :height="height" viewBox="0 0 640 480"
       class="elevation-3">
    <g fill-rule="evenodd" stroke-width="1pt">
      <path fill="#ffd700" d="M0 0h640v480H0z"/>
      <path fill="#0057b8" d="M0 0h640v240H0z"/>
    </g>
  </svg>

</template>

<script>

import {useDisplay} from 'vuetify'
import {computed} from "vue";

export default {
  name: "UkrainianLanguage",
  setup() {
    const {name} = useDisplay()
    // eslint-disable-next-line vue/return-in-computed-property
    const height = computed(() => {
      // name is reactive and
      // must use .value
      switch (name.value) {
        case 'xs':
          return 20
        case 'sm':
          return 30
        default:
          return 40
      }
    })
    return {height}
  }
}
</script>

<style scoped>

</style>